var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabbar"},_vm._l((_vm.tabs),function(item){return _c('router-link',{key:item.path,staticClass:"tabbar-item",attrs:{"to":item.path,"active-class":"active"}},[_c('i',{staticClass:"tabbar-icon",class:item.icon}),_c('span',{staticClass:"tabbar-label"},[_vm._v(_vm._s(item.label))])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }